import { render, staticRenderFns } from "./ItemM3.vue?vue&type=template&id=1433eee8&scoped=true&"
import script from "./ItemM3.vue?vue&type=script&lang=js&"
export * from "./ItemM3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1433eee8",
  null
  
)

export default component.exports